module.exports = __webpack_public_path__ + "img/tireExample.6522e2f4.svg";